import { ChangeDetectorRef, Component, ViewEncapsulation, ChangeDetectionStrategy, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { subDays } from 'date-fns';
import { formatDate, isBefore } from 'src/app/shared/utils/dates';
import { Router } from "@angular/router";
import * as _ from "lodash-es";
import { INotification } from "src/app/models/notification.model";
import { LivecoAPIService } from "src/app/services/liveco-api.service";
import { NotificationsService } from "src/app/services/notifications.service";
//@ts-ignore
import Mustache from 'mustache';
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { MatButton } from "@angular/material/button";
import { MatMenuTrigger, MatMenu, MatMenuItem } from "@angular/material/menu";
import { MatIcon } from "@angular/material/icon";
import { MatBadge } from "@angular/material/badge";
import { NgClass } from "@angular/common";
import { MatTooltip } from "@angular/material/tooltip";

// // @ts-ignore
// const api = require("@modules/cf-api.js").api;
// const api_async = require("@modules/cf-api.js").api_async;

@Component({
    selector: "app-notif-list",
    templateUrl: "./notif-list.component.html",
    styleUrls: ["./notif-list.component.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButton, MatMenuTrigger, MatIcon, MatBadge, MatMenu, MatMenuItem, NgClass, MatTooltip, TranslatePipe]
})
export class NotifListComponent {
    router = inject(Router);
    protected notifications = inject(NotificationsService);
    protected liveco = inject(LivecoAPIService);
    protected translate = inject(TranslateService);
    protected cd = inject(ChangeDetectorRef);

    constructor() {
        // The nav bar is OnPush: without this the bell only caught up with the list on the next
        // event inside the nav bar (a hover on the search field, for instance)
        this.notifications.entities$.pipe(takeUntilDestroyed()).subscribe(() => this.cd.markForCheck());
    }

    get notifs() {
        return this.notifications.entities;
    }

    get unseen() {
        return this.notifs.filter(n => !n.seen);
    }

    async goTo(notif: INotification) {
        // this.router.navigateByUrl('/', { skipLocationChange: true,  }).then(() => {
        //     this.router.navigate([notif.url], { queryParams: notif.data.queryParams ? notif.data.queryParams : {}, });
        // });
        if (!notif.opts?.external) {
            const url = this.router.serializeUrl(this.router.createUrlTree([notif.url], { queryParams: notif.data.queryParams ? notif.data.queryParams : {} }));
            window.open('#/' + url, '_blank');
        } else {
            window.open(notif.url, '_blank');
        }
    }

    getIcon(notif: INotification) {
        switch (notif.type) {
            case 'proofscope':
                return 'find_in_page';
            case 'error':
                return 'error';
            case 'briefing':
                return 'hourglass_bottom';
            case 'brief-files':
                return 'folder';
            case 'download':
                return 'download';
            case 'package':
                return 'local_shipping';
            default:
                return notif.type;
        }
    }

    getMessage(notif: INotification) {
        const message = this.translate.instant(notif.message);
        return Mustache.render(message, {
            ...notif.data
        });
    }

    async deleteNotif() {
        const promises = [];
        for (let notif of this.notifs) {
            if (notif._id)
                promises.push(this.liveco.delete(notif._id, 'notifications'));
        }
        await Promise.all(promises);
        await this.notifications.init();
        this.cd.markForCheck();
    }

    formatDate(date: Date | string) {
        return isBefore(date, subDays(new Date(), 1)) ? formatDate(date, 'dd/MM/yyyy') : formatDate(date, 'HH:mm');
    }

    async onOpen() {
        for (let notif of this.notifs) {
            if (notif._id && !notif.seen)
                await this.liveco.patch(notif._id, 'notifications', { seen: true });
        }
        await this.notifications.init();
    }
}
